// extracted by mini-css-extract-plugin
export var linkText = "_mu-0";